import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-net-worth',
  templateUrl: './icon-net-worth.component.html'
})
export class IconNetWorthComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
